import { useOrientedLayoutMode, type OrientedLayoutMode } from '@/hooks/useDeviceLayout'

export type ChatLayoutMode = OrientedLayoutMode

export function useChatLayoutMode(): ChatLayoutMode {
  return useOrientedLayoutMode()
}
